import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { Image, Col, Row, Button } from "react-bootstrap";
import { MdSearch } from "react-icons/md";
import editpic from "../../assets/edit.svg";
import deletepic from "../../assets/delete.svg";
import iicon from "../../assets/i-icon.svg";
import Loader from "../Loader/Loader";
import { DeleteCoupons } from "./../API/Coupons/DeleteCoupons";
import { UpdateStatus } from "./../API/Coupons/UpdateStatus";
import { TableListApi } from "../API/Communications/TableList";
import { DeleteTemplateApi } from "../API/Communications/DeleteRow";
import swal from "sweetalert";
import Pagination from "./../Pagination/Pagination";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import NoDataText from "../NoDataText";
import SearchBarResults from "../Search/SearchBarResults";
import { FormatDateShortMonth } from "../../Utils/DateFormatter";

export const ManageTemplate = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [TableRows, setTableRows] = useState([]);
  const [globalTableRows, setglobalTableRows] = useState([]);
  const [ShowTable, setShowTable] = useState(false);

  // checkbox
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  // AutoPublish
  const [AutoPublish, setAutoPublish] = useState([]);
  const [checkAutoPublish, setcheckAutoPublish] = useState(false);
  // search
  const [searchValue, setsearchValue] = useState("");
  // pagination
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [limit, setLimit] = useState(0);
  // sort
  const [flag, setFlag] = useState({
    mmsc_template_name: 0,
    mmsc_usage_count: 0,
    mmsc_opened_count: 0,
    created_at: 0,
  });

  // useEffect(() => {
  //   setLoading(true);
  //   // ApiOnLoad()
  // }, []);

  // search
  const handleSearchInput = (e) => {
    setsearchValue(e.target.value);
    if (e.target.value.length == 0) {
      setShowTable(false);
      setTableRows(globalTableRows);
    }
  };
  const handleKeypress = (e) => {
    if (e.code === "Enter") {
      handleSearch();
    }
  };
  const handleSearch = async (e) => {
    setLoading(true);
    ApiLoad(searchValue);
  };

  const ApiLoad = async (searchValue) => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      user_id: parseInt(cityId),
      offset: searchValue ? 0 : pageNumber,
      search_key: searchValue,
    };
    const coupondetailData = await TableListApi(data, () => {
      navigate("/");
    });

    if (coupondetailData.success === false) {
      setShowTable(true);
      setLoading(false);
      setTableRows(coupondetailData.data);
    } else if (coupondetailData.status === 429) {
      setLoading(true);
      swal({
        text: `${coupondetailData.message}`,
        icon: "error",
        buttons: "Ok",
        dangerMode: false,
      });
    } else {
      setShowTable(false);
      setTableRows(coupondetailData.data);
      // setglobalTableRows(coupondetailData.data);
      setLoading(false);
    }
  };

  // onload Api
  const ApiOnLoad = async (searchValue) => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      user_id: parseInt(cityId),
      offset: 0,
      search_key: searchValue,
    };
    const coupondetailData = await TableListApi(data, () => {
      navigate("/");
    });

    if (coupondetailData.success === false) {
      setShowTable(true);
      setLoading(false);
    } else if (coupondetailData.status === 429) {
      setLoading(true);
      swal({
        text: `${coupondetailData.message}`,
        icon: "error",
        buttons: "Ok",
        dangerMode: false,
      });
    } else {
      setShowTable(false);
      setTableRows(coupondetailData.data);
      setglobalTableRows(coupondetailData.data);
      setLoading(false);
    }
  };

  // pagination
  const pageChange = async () => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      user_id: parseInt(cityId),
      offset: pageNumber,
      limit: 10,
    };
    const coupondetailData = await TableListApi(data, () => {
      navigate("/");
    });
    if (coupondetailData.status === 429) {
      setLoading(true);
      swal({
        text: `${coupondetailData.message}`,
        icon: "error",
        buttons: "Ok",
        dangerMode: false,
      });
    } else {
      setTableRows(coupondetailData.data);
      setglobalTableRows(coupondetailData.data);
      setTotalPageCount(coupondetailData.total_row_count);
      setLimit(coupondetailData.limit);
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    pageChange();
  }, [pageNumber]);

  // checkbox - th
  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(TableRows?.map((li) => li.template_id));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };
  // checkbox - tr
  const handleClick = (e, key) => {
    const { checked } = e.target;
    setIsCheck([...isCheck, TableRows[key].template_id]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== TableRows[key].template_id));
    }
  };

  const handleChangeDropDownTop = (e) => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      option: "status",
      coupon_id: isCheck,
      status_id: parseInt(e.target.value),
    };
    const coupondetailData = UpdateStatus(data, () => {
      navigate("/");
    });
    // console.log(coupondetailData, "coupondetailData");
    setTimeout(() => {
      window.location.reload(false);
    }, 1000);
    setLoading(false);
  };

  // Delete
  const handleDelete = () => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");
    const data = {
      user_id: parseInt(cityId),
      template_id: isCheck,
    };
    swal({
      title: `Are you sure you want to delete selected Templates?`,
      text: "Once deleted, you will not be able to recover!",
      icon: "error",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        DeleteTemplateApi(data, () => {
          navigate("/");
        });
        swal({
          // title: "Success!",
          title: `Selected Templates has been deleted successfully!`,
          icon: "success",
          buttons: "Ok",
        }).then(() => {
          window.location.reload();
        });
      } else {
        swal({
          text: "Please wait...",
          icon: "error",
          buttons: "Ok",
        });

        setTimeout(() => {
          window.location.reload(false);
        }, 1000);
      }
    });
    setLoading(false);
  };

  const handleDeleteEach = async (e, key) => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      user_id: parseInt(cityId),
      template_id: [TableRows[key].template_id],
    };
    swal({
      title: `Are you sure you want to delete ${TableRows[key].template_name}?`,
      text: "Once deleted, you will not be able to recover!",
      icon: "error",
      buttons: true,
      dangerMode: false,
    }).then(async (willDelete) => {
      if (willDelete) {
        setLoading(true);
        const DeleteRes = await DeleteTemplateApi(data, () => {
          navigate("/");
        });
        if (DeleteRes === false) {
          setLoading(false);
          swal({
            text: "Internal Server Error!",
            icon: "error",
            buttons: "Ok",
          });
        } else {
          if (DeleteRes.success === true) {
            setLoading(false);
            swal({
              // title: "Success!",
              title: `${TableRows[key].template_name} has been deleted successfully!`,
              icon: "success",
              buttons: "Ok",
            }).then(() => {
              window.location.reload(false);
            });
          } else if (DeleteRes.status === 429) {
            swal({
              // title: "Success!",
              title: `${DeleteRes.message} `,
              icon: "error",
              buttons: "Ok",
            });
            setLoading(true);
          } else {
            setLoading(false);
            swal({
              text: DeleteRes.message,
              icon: "error",
              buttons: "Ok",
            });
          }
        }
      }
    });
  };

  const handlecreateTemplate = () => {
    navigate("/communications/manage-templates/create-template");
  };

  // sort
  // Api for sort
  const handleSort = async (search, sortNo, colValue) => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      user_id: parseInt(cityId),
      limit: 5,
      offset: search ? 0 : pageNumber,
      search_value: search,
      column_name: colValue,
      sort_type: sortNo,
    };
    const coupondetailData = await TableListApi(data, () => {
      navigate("/");
    });
    // console.log(coupondetailData,"coupondetailData")
    setLoading(false);
    if (coupondetailData.status === 429) {
      setLoading(true);
      swal({
        text: `${coupondetailData.message}`,
        icon: "error",
        buttons: "Ok",
        dangerMode: false,
      });
    } else if (coupondetailData.message === "No Data Available") {
      setShowTable(true);
      setLoading(false);
    } else {
      setLoading(false);
      setShowTable(false);
      setTableRows(coupondetailData.data);
      setglobalTableRows(coupondetailData.data);
      setTotalPageCount(coupondetailData.total_row_count);
      setLimit(coupondetailData.limit);
    }
  };

  // function to sort-button
  const HandleSortCol = (value) => {
    // mmsc_template_name: 0,
    if (value == "mmsc_template_name") {
      if (flag.mmsc_template_name === 0) {
        handleSort(searchValue, 1, "mmsc_template_name");
        setFlag((item) => {
          return { ...item, mmsc_template_name: 1 };
        });
      } else if (flag.mmsc_template_name === 1) {
        handleSort(searchValue, 2, "mmsc_template_name");
        setFlag((item) => {
          return { ...item, mmsc_template_name: 2 };
        });
      } else {
        handleSort(searchValue, 0, "mmsc_template_name");
        setFlag((item) => {
          return { ...item, mmsc_template_name: 0 };
        });
      }
    }
    // mmsc_usage_count: 0,
    if (value == "mmsc_usage_count") {
      if (flag.mmsc_usage_count === 0) {
        handleSort(searchValue, 1, "mmsc_usage_count");
        setFlag((item) => {
          return { ...item, mmsc_usage_count: 1 };
        });
      } else if (flag.mmsc_usage_count === 1) {
        handleSort(searchValue, 2, "mmsc_usage_count");
        setFlag((item) => {
          return { ...item, mmsc_usage_count: 2 };
        });
      } else {
        handleSort(searchValue, 0, "mmsc_usage_count");
        setFlag((item) => {
          return { ...item, mmsc_usage_count: 0 };
        });
      }
    }
    // mmsc_opened_count:0
    if (value == "mmsc_opened_count") {
      if (flag.mmsc_opened_count === 0) {
        handleSort(searchValue, 1, "mmsc_opened_count");
        setFlag((item) => {
          return { ...item, mmsc_opened_count: 1 };
        });
      } else if (flag.mmsc_opened_count === 1) {
        handleSort(searchValue, 2, "mmsc_opened_count");
        setFlag((item) => {
          return { ...item, mmsc_opened_count: 2 };
        });
      } else {
        handleSort(searchValue, 0, "mmsc_opened_count");
        setFlag((item) => {
          return { ...item, mmsc_opened_count: 0 };
        });
      }
    }
    // created_at: 0,
    if (value == "created_at") {
      if (flag.created_at === 0) {
        handleSort(searchValue, 1, "created_at");
        setFlag((item) => {
          return { ...item, created_at: 1 };
        });
      } else if (flag.created_at === 1) {
        handleSort(searchValue, 2, "created_at");
        setFlag((item) => {
          return { ...item, created_at: 2 };
        });
      } else {
        handleSort(searchValue, 0, "created_at");
        setFlag((item) => {
          return { ...item, created_at: 0 };
        });
      }
    }
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="manage-vou-main pt-3 pb-3 manage_Templates">
        <div>
          <p className="page-maintitle pt-2">Manage Templates</p>
        </div>
        <div className="manage-vou">
          <InputGroup className="search-bar comm">
            <InputGroup.Text>
              <MdSearch />
            </InputGroup.Text>
            <Form.Control
              className="search_feild"
              value={searchValue}
              onChange={(e) => handleSearchInput(e)}
              onKeyPress={handleKeypress}
            />
            <Button variant="outline-secondary " onClick={handleSearch}>
              Search
            </Button>
          </InputGroup>
          <Button
            variant="primary"
            className="create-btn export-btn-main createTemplate"
            onClick={handlecreateTemplate}
          >
            + Create Template
          </Button>
        </div>
      </div>
      <SearchBarResults SearchValue={searchValue} />
      {isCheck.length != 0 ? (
        <div className="d-flex">
          <Button
            className="green-btn width-150 p-0 mr-3 del_btn"
            onClick={handleDelete}
          >
            Delete Selected
          </Button>
        </div>
      ) : (
        ""
      )}
      {/* table */}

      <div class="table-responsive-xl black-header">
        <table class="recentact-table mt-3 table ver-middle manage-vou-table man-temp-table">
          <thead>
            <tr>
              <th className="radio-colors">
                <Form.Check
                  aria-label="option 1"
                  className="orange-checkbox"
                  onChange={handleSelectAll}
                  checked={isCheckAll}
                />
              </th>
              <th
                onClick={() => HandleSortCol("mmsc_template_name")}
                style={{ textAlign: "left", width: "300px" }}
              >
                <Button className="btn btn-primary sortIcon">
                  Template Name
                  {flag.mmsc_template_name === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.mmsc_template_name === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th
                onClick={() => HandleSortCol("mmsc_usage_count")}
                style={{ textAlign: "center" }}
              >
                Usage
                {flag.mmsc_usage_count === 0 ? (
                  <FaSort></FaSort>
                ) : flag.mmsc_usage_count === 1 ? (
                  <FaSortUp></FaSortUp>
                ) : (
                  <FaSortDown></FaSortDown>
                )}
              </th>
              <th
                onClick={() => HandleSortCol("created_at")}
                style={{ textAlign: "center" }}
              >
                Created Date
                {flag.created_at === 0 ? (
                  <FaSort></FaSort>
                ) : flag.created_at === 1 ? (
                  <FaSortUp></FaSortUp>
                ) : (
                  <FaSortDown></FaSortDown>
                )}
              </th>
              <th style={{ textAlign: "center" }}>Opened</th>
              <th className="action-min-main" style={{ textAlign: "center" }}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {TableRows?.length !== 0 ? (
              <>
                {TableRows?.map((item, key) => {
                  const templateName = item.template_name.replace(/ /g, "-");
                  //  console.log(templateName,"templateName")
                  return (
                    <tr>
                      <td className="radio-colors">
                        <Form.Check
                          aria-label="option 1"
                          className="orange-checkbox"
                          onChange={(e) => handleClick(e, key)}
                          checked={isCheck.includes(item.template_id)}
                        />
                      </td>
                      <td style={{ textAlign: "left" }}>
                        {item.template_name}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {item.usage_count}
                      </td>
                      <td className="date-col" style={{ textAlign: "center" }}>
                        {FormatDateShortMonth(item.created_at)}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {item.opened_count}{" "}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <div
                          className="action-min-img"
                          style={{ justifyContent: "center", gap: "10px" }}
                        >
                          <Link
                            to={`/communications/manage-templates/edit-template/${item.template_id}-${templateName}`}
                          >
                            <Image src={editpic} title="Edit"></Image>
                          </Link>
                          <div>
                            <Image
                              src={deletepic}
                              title="Delete"
                              width="18px"
                              onClick={(e) => handleDeleteEach(e, key)}
                            ></Image>
                          </div>
                          <Link
                            to={`/communications/manage-templates/view-template/id=${item.template_id}`}
                          >
                            <Image
                              src={iicon}
                              width="18px"
                              title="View"
                            ></Image>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </>
            ) : (
              <tr class="toggle-row">
                <td colspan="8">
                  <p class="noData">{NoDataText.ErrText}</p>{" "}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {totalPageCount > 10 ? (
        <Pagination
          totalPageCount={totalPageCount}
          setPageNumber={setPageNumber}
          limit={limit}
        />
      ) : (
        <></>
      )}
    </>
  );
};
